import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import InsertPhotoIcon from '@material-ui/icons/InsertPhotoOutlined';
import PDFIcon from '@material-ui/icons/PictureAsPdf';
import AspectIcon from '@material-ui/icons/AspectRatio';
import CameraIcon from '@material-ui/icons/CameraEnhanceOutlined';
import DescriptionIcon from '@material-ui/icons/DescriptionOutlined';

import ExportLink from 'components/Widgets/Tables/common/components/ExportLink';
import ExportButton from 'components/buttons/ExportButton/ExportButton';

const useStyles = makeStyles(() => ({
  menuTitle: {
    textTransform: 'uppercase',
    fontWeight: '600'
  },
  gridWidth: {
    maxWidth: '200px'
  }
}));

const EXPORT_OPTIONS = {
  COMMON: [
    {
      value: 'png',
      icon: <InsertPhotoIcon color="inherit" />,
      color: '#346C9F'
    },
    {
      value: 'pdf',
      icon: <PDFIcon />,
      color: '#DB3535'
    },
    { value: 'csv', icon: <DescriptionIcon />, color: '#07A7D3' }
  ],
  TABLE: {
    value: 'jpg',
    icon: <CameraIcon />,
    color: '#FFA500'
  },
  CHART: { value: 'svg', icon: <AspectIcon />, color: '#009B0C' }
};

const ExportMenu = ({ tableData, exportChart, exportTable, handleClose }) => {
  const classes = useStyles();

  const renderChartExport = () => {
    return (
      EXPORT_OPTIONS &&
      [...EXPORT_OPTIONS.COMMON, EXPORT_OPTIONS.CHART].map(option => (
        <ExportButton option={option} handleClick={exportChart} />
      ))
    );
  };

  const renderTableExport = () => {
    return (
      EXPORT_OPTIONS &&
      [...EXPORT_OPTIONS.COMMON, EXPORT_OPTIONS.TABLE].map(option => {
        if (option.value === 'csv') {
          return (
            <ExportButton
              option={option}
              handleClick={handleClose}
              Component={ExportLink}
              componentProps={{ data: tableData }}
            />
          );
        }

        return (
          <ExportButton
            option={option}
            handleClick={() => exportTable(option.value, tableData.title)}
          />
        );
      })
    );
  };

  return (
    <Grid
      container
      direction="row"
      justify="center"
      alignItems="center"
      spacing={1}
      className={classes.gridWidth}
    >
      <Grid item xs={10}>
        <Typography variant="subtitle2" className={classes.menuTitle} gutterBottom>
          EXPORT FILE
        </Typography>
      </Grid>
      {tableData ? renderTableExport() : renderChartExport()}
    </Grid>
  );
};

ExportMenu.propTypes = {
  tableData: PropTypes.shape({
    title: PropTypes.string
  }),
  exportChart: PropTypes.func,
  exportTable: PropTypes.func,
  handleClose: PropTypes.func.isRequired
};

ExportMenu.defaultProps = {
  tableData: null,
  exportChart: null,
  exportTable: null
};

export default ExportMenu;
